import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DirtinessService {
  isDirtySubject = new BehaviorSubject<boolean>(false);
  constructor() { }

  setDirty(isDirty: boolean) {
    this.isDirtySubject.next(isDirty);
  }

  dirtinessChanges(){
    return this.isDirtySubject;
  }
}
